import { useTheme } from '@mui/material';

export const LabelColors = () => {
  const theme = useTheme();
  const allColors = [
    theme.palette.taskboard.lightGreen,
    theme.palette.warning.lighter,
    theme.palette.taskboard.lightPeach,
    theme.palette.error.lighter,
    theme.palette.taskboard.lightLavender,
    theme.palette.success.main,
    theme.palette.warning.light,
    theme.palette.warning.main,
    theme.palette.taskboard.salmonPink,
    theme.palette.taskboard.lightPurple,
    theme.palette.success.dark,
    theme.palette.warning.dark,
    theme.palette.taskboard.burntOrange,
    theme.palette.error.dark,
    theme.palette.tertiary.light,
    theme.palette.grey[200],
    theme.palette.quaternary.lightBlue,
    theme.palette.success.light,
    theme.palette.taskboard.lightPink,
    theme.palette.grey[100],
    theme.palette.quaternary.ceruleanBlue,
    theme.palette.quaternary.lightGreen,
    theme.palette.taskboard.celery,
    theme.palette.taskboard.carissma,
    theme.palette.grey[400],
    theme.palette.quaternary.dark,
    theme.palette.taskboard.tealBlue,
    theme.palette.taskboard.oliveGreen,
    theme.palette.taskboard.mysticMaroon,
    theme.palette.grey[200],
  ];
  return allColors;
};
